import { useTranslation } from 'react-i18next'

import { Button } from 'src/components/Button/Button'
import styles from 'src/components/Collection/CollectionFilters.module.scss'
import { PRODUCT_FILTERS } from 'src/selectors'

interface CollectionFiltersProps {
  filters: string[]
  activeFilter: string
  onSelect: Function
}

export const CollectionFilters = ({ filters, activeFilter, onSelect }: CollectionFiltersProps) => {
  const { t } = useTranslation()

  return (
    <div className={styles.categories} data-cy={PRODUCT_FILTERS}>
      <Button
        onClick={() => {
          onSelect('')
        }}
        variant="secondary"
        active={!activeFilter}
      >
        {t('cms.blogCategories.all')}
      </Button>

      {filters.map((filter) => (
        <Button
          onClick={() => {
            onSelect(activeFilter === filter ? '' : filter)
          }}
          key={filter}
          variant="secondary"
          active={activeFilter === filter}
        >
          {filter}
        </Button>
      ))}
    </div>
  )
}
